import React, { FC, ImgHTMLAttributes } from 'react'
import styled from 'styled-components'

const ImageStyles = styled.img`
  vertical-align: bottom;
  border-radius: 2px;
  object-fit: cover;
`

export interface ImageProps extends ImgHTMLAttributes<{}> {
  importance?: 'low' | 'high'
}

const ImageBox: FC<ImageProps> = props => <img {...(props as any)} />

export default ImageStyles.withComponent(ImageBox)
